import { IIndex } from '../interface/IIndex';
import { authenticatedApi } from './api';

const getAll = async () => {
  return authenticatedApi.get(`index/all`);
};

const updateAll = async (indexes: Partial<IIndex>[]) => {
  return authenticatedApi.put(`index/update`, indexes);
};

const indexApi = { getAll, updateAll };

export default indexApi;
